module.exports = __webpack_public_path__ + "img/feedback.ca7b6c84.svg";